module.exports = "/fonts/logo-pajakku-aa293b8903127cd6b7c5f19da0ec4ee6.svg";